import * as SightingsConstants from '../../action/sightings/SightingsConstants';

const initialState = {
  getImageCommentsIsLoading: true,
  getImageCommentsData: {},
  getImageCommentsErrorMessage: '',

  addMessageToOneImageIsLoading: true,
  addMessageToOneImageData: {},
  addMessageToOneImageErrorMessage: '',

  addMessageToAllImagesIsLoading: true,
  addMessageToAllImagesData: {},
  addMessageToAllImagesErrorMessage: ''
};

export const sightingsStore = (state = initialState, action) => {
  switch (action.type) {
    case SightingsConstants.GET_IMAGE_COMMENTS_REQUEST:
      return {
        ...state,
        getImageCommentsIsLoading: true,
        getImageCommentsErrorMessage: ''
      };
    case SightingsConstants.GET_IMAGE_COMMENTS_SUCCESS:
      return {
        ...state,
        getImageCommentsIsLoading: false,
        getImageCommentsData: action.data
      };
    case SightingsConstants.GET_IMAGE_COMMENTS_FAILED:
      return {
        ...state,
        getImageCommentsIsLoading: false,
        getImageCommentsErrorMessage: action.error.response.data
      };

    case SightingsConstants.ADD_MSG_TO_ALL_IMAGES_REQUEST:
      return {
        ...state,
        addMessageToAllImagesIsLoading: true,
        addMessageToAllImagesErrorMessage: ''
      };
    case SightingsConstants.ADD_MSG_TO_ALL_IMAGES_SUCCESS:
      return {
        ...state,
        addMessageToAllImagesIsLoading: false,
        addMessageToAllImagesData: action.data
      };
    case SightingsConstants.ADD_MSG_TO_ALL_IMAGES_FAILED:
      return {
        ...state,
        addMessageToAllImagesIsLoading: false,
        addMessageToAllImagesErrorMessage: action.error.response.data
      };

    case SightingsConstants.ADD_MSG_TO_ONE_IMAGE_REQUEST:
      return {
        ...state,
        addMessageToOneImageIsLoading: true,
        addMessageToOneImageErrorMessage: ''
      };
    case SightingsConstants.ADD_MSG_TO_ONE_IMAGE_SUCCESS:
      return {
        ...state,
        addMessageToOneImageIsLoading: false,
        addMessageToOneImageData: action.data
      };
    case SightingsConstants.ADD_MSG_TO_ONE_IMAGE_FAILED:
      return {
        ...state,
        addMessageToOneImageIsLoading: false,
        addMessageToOneImageErrorMessage: action.error.response.data
      };

    default:
      return state;
  }
};
